import React, { useContext, useState, useEffect, useRef } from 'react';
import { Table, Input, Button, Popconfirm, Form, Switch, Space } from 'antd';
import { CheckOutlined, CloseOutlined} from '@ant-design/icons'

const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef();
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async e => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
  }

  return <td {...restProps}>{childNode}</td>;
};

class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: '#',
        render: (text, record, index) => index + 1
      },
      {
        title: 'Name',
        dataIndex: 'name',
        width: '20%',
        editable: true,
      },
      {
        title: 'Arabic',
        dataIndex: 'display_text_ar',
        width: '20%',
        editable: true,
      },
      {
        title: 'Type',
        dataIndex: 'type',
        width: '40%',

        render: (text, record) => {
          return(
            <Space>
              <Switch checkedChildren="Inventory" unCheckedChildren="Inventory" defaultChecked={record?.is_inventory_item} onChange={(e) => this.handleSave(record, 'is_inventory_item', e)} />
              <Switch checkedChildren="Branch Inventory" unCheckedChildren="Branch Inventory" defaultChecked={record?.is_branch_inventory_item} onChange={(e) => this.handleSave(record, 'is_branch_inventory_item', e)} />
              <Switch checkedChildren="Only Branch" unCheckedChildren="Only Branch" defaultChecked={record?.is_branch_only_inventory_item} onChange={(e) => this.handleSave(record, 'is_branch_only_inventory_item', e)} />
              <Switch checkedChildren="POS" unCheckedChildren="POS" defaultChecked={record?.is_pos_item} onChange={(e) => this.handleSave(record, 'is_pos_item', e)} />
            </Space>
          )
        },
        filters: [
          {
            text: 'Inventory (Purchase)',
            value: 'is_inventory_item',
          },
          {
            text: 'Branch Inventory',
            value: 'is_branch_inventory_item',
          },
          {
            text: 'Branch Only Inventory',
            value: 'is_branch_only_inventory_item',
          },
          {
            text: 'POS',
            value: 'is_pos_item',
          },
        ],
        onFilter: (value, record) => record[value] === true,
      },
      {
        title: 'Store',
        dataIndex: 'price',
      },
          
      {
        title: '',
        dataIndex: 'operation',
        render: (text, record) =>
          this.state.dataSource.length >= 1 ? (

            <a href={`/store/admin/products/${record.slug}/edit`} >More...</a>

          ) : null,
      },
    ];
    this.state = {
      
    };
  }

  componentDidMount() {
    this.setState({ loading: true })
    var url = Spree.url('/api/v1/products', {
      token: Spree.api_key
    });
    const $this = this;
    return $.getJSON(url, null, function (data) {

      $this.setState({ dataSource: data.products, recordCount: data.count })
      console.log("data", data)
      $this.setState({ loading: false })

    });

  }

  saveChanges = (selected, type, record) => {
    const typeKey = "product[" + type + "]"
    $.ajax({
      type: "POST",
      dataType: 'json',
      url: '/api/v1/products',
      data: {
        "product[id]": record.id, [typeKey]: selected, token: Spree.api_key
      },
      success: function (data) {
        console.log(`product saved. ${record.name}`, type, selected)

      }
    });
    
  }
  
  

  handleDelete = key => {
    const dataSource = [...this.state.dataSource];
    this.setState({
      dataSource: dataSource.filter(item => item.key !== key),
    });
  };

  handleAdd = () => {
    alert('Work in progress...')
    return;
    const { count, dataSource } = this.state;
    const newData = {
      key: count,
      name: `New Product`,
      age: 32,
      address: `London, Park Lane no. ${count}`,
    };
    this.setState({
      dataSource: [...dataSource, newData],
      count: count + 1,
    });
  };

  handleSave = (row, column, value) => {
    // e, 'is_inventory_item', record

    const newData = [...this.state.dataSource];

    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];
    if (value !== undefined) item[column] = value; //switch changes are not assigned to the record
    newData.splice(index, 1, { ...item, ...row });
    this.setState({
      dataSource: newData,
    });
    const newValue = value !== undefined ? value : row[column]
    this.saveChanges(newValue, column, row)
  };

  render() {
    const { dataSource, loading, recordCount } = this.state;
    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    };
    const columns = this.columns.map(col => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: (e) => this.handleSave(e, col.dataIndex),
        }),
      };
    });
    return (
      <div>
        <Space>
        <Button
          onClick={this.handleAdd}
          type="primary"
          style={{
            marginBottom: 16,
          }}
        >
          
        </Button>
        
          {recordCount} Items
        </Space>
        <Table
          components={components}
          rowClassName={() => 'editable-row'}
          bordered
          dataSource={dataSource}
          columns={columns}
          rowKey="id"
          loading={loading}
          pagination={false}
          onChange={(pagination, filters, sorter, extra) => { this.setState({ recordCount: extra.currentDataSource.length})} }

        />
      </div>
    );
  }
}

export default EditableTable;
